import React from 'react';
import moment from 'moment';
import { isEqual } from 'lodash';
import { Image } from 'react-bootstrap';
import { FileIcon } from 'react-file-icon';

import { TOST_MESSAGE, TOAST_TYPE } from './constant/errorMessage';
import { notification } from './notification';
import { DATE_FILTER_KEYS, DEPARTMENT_KEYS } from './constant/global';

const { TOAST_ERROR } = TOAST_TYPE;
const { THIS_MONTH, THIS_WEEK, TODAY } = DATE_FILTER_KEYS;

export const convertTimeStamp = (date) => {
  const timeStamp = new Date(date).getTime();
  return timeStamp;
};

export const editDateFormate = (dates) => {
  const dateFormate = moment(dates).format('YYYY-MM-DD');
  return dateFormate;
};

export const HTTP_METHODS = {
  GET: 'get',
  POST: 'post',
  PUT: 'put',
  DELETE: 'delete',
  PATCH: 'patch'
};

export const emptyValidation = (data) => {
  if (typeof data !== 'object' || data === null) {
    if (
      data === undefined ||
      data === null ||
      data === 0 ||
      data === '' ||
      data === ' ' ||
      data === isNaN
    ) {
      return true;
    }
  } else if (typeof data === 'object') {
    if (Object.keys(data).length === 0) {
      return true;
    }
  } else if (Array.isArray(data)) {
    if (data.length === 0) {
      return true;
    }
  }

  return false;
};

export const buildQueryString = (params) => {
  const queryString = Object.keys(params)
    .filter((key) => !emptyValidation(params[key]))
    .map((key) => `${key}=${params[key]}`)
    .join('&');
  return queryString ? `?${queryString}` : '';
};

export const fullName = (row) => {
  const name = String(row?.name || row?.userName || '').trim();
  return name || '-';
};

export const getEmployeeDisplayName = (row) => fullName(row);

export const profileImageFullName = (row) => {
  const displayName = getEmployeeDisplayName(row);
  const renderAvatar = () => {
    if (row.profilePicture) {
      return (
        <>
          <Image
            src={row.profilePicture}
            roundedCircle
            style={{ width: '40px', height: '40px', display: 'inline-block', flexShrink: 0 }}
          />
          <span className="employee-name-cell__text">{displayName}</span>
        </>
      );
    }

    const initials = displayName
      .split(' ')
      .filter(Boolean)
      .map((namePart) => namePart.charAt(0).toUpperCase())
      .join('')
      .slice(0, 2);
    return (
      <>
        <img
          src={`https://ui-avatars.com/api/?name=${encodeURIComponent(initials || 'U')}&rounded=true&background=484c7f&color=fff`}
          alt={displayName}
          style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            display: 'inline-block',
            flexShrink: 0
          }}
        />
        <span className="employee-name-cell__text">{displayName}</span>
      </>
    );
  };

  return (
    <span className={`employee-name-cell ${row.txtClass || ''}`.trim()}>{renderAvatar()}</span>
  );
};

export const formatDate = (date, format = 'DD-MMM-YYYY') => {
  if (emptyValidation(date)) {
    return '-';
  } else {
    const momentDate = moment(date);
    if (momentDate.isValid()) {
      return momentDate.format(format);
    } else {
      return '-';
    }
  }
};

export const timeStampFormatDate = (timestamp, format = 'DD-MMM-YYYY') => {
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ];
  const date = new Date(timestamp);
  const day = date.getDate().toString().padStart(2, '0');
  const month = months[date.getMonth()];
  const year = date.getFullYear();
  switch (format) {
    case 'DD-MMM-YYYY':
      return `${day}-${month}-${year}`;
    case 'MMM YYYY':
      return `${month} ${year}`;
    default:
      return `${day}-${month}-${year}`;
  }
};

export const paginationRow = (isNext, rowParPage, currentPage, dataLength, totalCount) => {
  if (typeof totalCount === 'number') {
    return totalCount;
  }

  const row = isNext ? rowParPage * currentPage + dataLength : rowParPage * currentPage;

  return row;
};

export const skipRow = (currentPage, rowsPerPage) => {
  const skip = currentPage === 1 ? 0 : rowsPerPage * currentPage - rowsPerPage;
  return skip;
};

const areObjectsEqual = (obj1, obj2) => {
  return JSON.stringify(obj1) === JSON.stringify(obj2);
};

export const matchData = (leaveRequest, defaultValues) => {
  const updatedValues = Object.keys(leaveRequest).reduce((acc, key) => {
    if (Array.isArray(leaveRequest[key])) {
      if (leaveRequest[key].length === defaultValues[key].length) {
        const arrayChanges = leaveRequest[key].filter((item, index) => {
          return !areObjectsEqual(item, defaultValues[key][index]);
        });

        if (arrayChanges.length > 0) {
          acc[key] = leaveRequest[key];
        }
      } else {
        acc[key] = leaveRequest[key];
      }
    } else if (!isEqual(leaveRequest[key], defaultValues[key])) {
      acc[key] = leaveRequest[key];
    }
    return acc;
  }, {});

  return updatedValues;
};

export const getErrorMessage = (field, errors) => {
  return errors[field]?.message;
};

export const getStatusBadge = (row, key) => {
  const badgeClass =
    row[key] === 'Approved' ? 'success' : row[key] === 'Rejected' ? 'danger' : 'warning';
  const statusText =
    row[key] === 'Approved' ? 'Approved' : row[key] === 'Rejected' ? 'Rejected' : 'Pending';

  return (
    <span
      className={`badge bg-${badgeClass} text-white`}
      style={{ fontSize: '12px', padding: '6px' }}
    >
      {statusText}
    </span>
  );
};

export const getUserName = (data) => {
  if (data?.name) {
    return data.name;
  } else if (data?.firstName && data?.lastName) {
    return data.firstName + data.lastName;
  }
  return '';
};

export const withoutProfilePicture = (row) => {
  if (!row || !row.name) {
    return '';
  }

  const initials = row.name
    .split(' ')
    .map((namePart) => namePart.charAt(0).toUpperCase())
    .join('');

  return `https://ui-avatars.com/api/?name=${initials}&rounded=true&background=484c7f&color=fff`;
};

export const downloadFile = async (file) => {
  try {
    // const supportedMimeTypes = [
    //   'image/png',
    //   'image/jpeg',
    //   'application/pdf',
    //   'application/msword',
    //   'text/plain'
    // ];
    const supportedMimeTypes = [
      // Images
      'image/jpeg',
      'image/png',
      'image/gif',
      'image/bmp',
      'image/webp',
      'image/svg+xml',
      'image/tiff',

      // Documents
      'application/pdf',
      'application/msword', // .doc
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
      'application/vnd.ms-excel', // .xls
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
      'application/vnd.ms-powerpoint', // .ppt
      'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .pptx
      'text/plain',
      'text/csv',
      'application/rtf',

      // Archives
      'application/zip',
      'application/x-zip-compressed',
      'application/x-rar-compressed',
      'application/x-7z-compressed',
      'application/gzip',

      // Audio
      'audio/mpeg', // .mp3
      'audio/wav',
      'audio/ogg',
      'audio/mp4',
      'audio/webm',

      // Video
      'video/mp4',
      'video/ogg',
      'video/webm',
      'video/x-msvideo', // .avi
      'video/quicktime', // .mov
      'video/x-matroska' // .mkv
    ];

    if (!supportedMimeTypes.includes(file.mimeType)) {
      console.error('Unsupported file format:', file.mimeType);
      return;
    }

    const response = await fetch(file.url);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = file.fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading file:', error);
  }
};

export const downloadFileFromURL = async (fileUrl) => {
  try {
    // Extract the file name from the URL (everything after the last "/")
    const fileName = fileUrl.substring(fileUrl.lastIndexOf('/') + 1);

    // Fetch the file from the provided URL
    const response = await fetch(fileUrl);

    // Check if the response is OK (status 200)
    if (!response.ok) {
      throw new Error('Failed to fetch the file.');
    }

    // Convert the response to a blob
    const blob = await response.blob();

    // Create a temporary URL for the blob
    const url = window.URL.createObjectURL(blob);

    // Create a link element
    const link = document.createElement('a');
    link.href = url;

    // Use the extracted file name from the URL
    link.download = fileName;

    // Append the link to the document body and simulate a click
    document.body.appendChild(link);
    link.click();

    // Clean up by removing the link and revoking the URL
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading file:', error);
  }
};

export const downloadFileFromURLS3 = async (url, filename) => {
  try {
    const response = await fetch(url, { method: 'GET' });
    if (!response.ok) throw new Error('Failed to fetch file');

    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = filename || url.split('/').pop().split('?')[0];
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);
  } catch (err) {
    console.error('Download failed:', err);
  }
};

export const deleteKeysFromObj = (object, keys) => {
  if (keys.length > 0) {
    keys.forEach((key) => {
      if (key in object) {
        delete object[key];
      }
    });
  }
  return object;
};

export const isAttendanceViolationLeaveType = (leaveType = {}) => {
  const name = String(leaveType?.name || '')
    .trim()
    .toLowerCase();
  return name.includes('early exit') || name.includes('late arrival');
};

export const mergeAttendanceViolationLeaveTypes = (baseTypes = [], allTypes = []) => {
  const merged = [...(baseTypes || [])];
  const seen = new Set(merged.map((item) => item?._id));

  (allTypes || []).forEach((item) => {
    if (!item?._id || seen.has(item._id)) return;
    if (!isAttendanceViolationLeaveType(item)) return;
    merged.push(item);
    seen.add(item._id);
  });

  return merged;
};

export const isLeaveTypeApplicableForUser = (leaveType, user = {}) => {
  if (isAttendanceViolationLeaveType(leaveType)) return true;

  const allowedGenders = leaveType?.applicable?.gender;
  if (!Array.isArray(allowedGenders) || allowedGenders.length === 0) return true;

  const userGender = String(user?.gender || '').trim();
  if (!userGender) return true;

  return allowedGenders.includes(userGender);
};

export const filterLeaveTypesForUser = (leaveTypes = [], user = {}, { forAdmin = false } = {}) => {
  if (forAdmin || !Array.isArray(leaveTypes)) return leaveTypes || [];
  return leaveTypes.filter((leaveType) => isLeaveTypeApplicableForUser(leaveType, user));
};

const TECHNICAL_AUTH_ERROR_PATTERN =
  /cannot read properties of|null \(reading|typeerror|referenceerror/i;

export const getAuthErrorMessage = (res, fallback = TOST_MESSAGE.LOGIN_FAILED) => {
  const raw =
    res?.error?.data?.statusMessage || res?.error?.message || res?.data?.statusMessage || '';

  const trimmed = String(raw).trim();
  if (!trimmed) return fallback;

  if (TECHNICAL_AUTH_ERROR_PATTERN.test(trimmed)) {
    const statusCode = Number(
      res?.error?.data?.statusCode ?? res?.error?.status ?? res?.data?.statusCode ?? 0
    );
    return statusCode >= 500 ? TOST_MESSAGE.LOGIN_SERVER_ERROR : fallback;
  }

  return trimmed;
};

export const handleApiError = (error) => {
  let message = error?.message;

  if (error?.data?.data?.message) {
    message = `${error?.data?.statusMessage}: ${error.data.data.message}`;
  } else if (error?.data?.statusMessage) {
    message = error?.data?.statusMessage;
  }

  notification(message, TOAST_ERROR);
};

export const getMonthNumberByName = {
  jan: 1,
  feb: 2,
  mar: 3,
  apr: 4,
  may: 5,
  jun: 6,
  jul: 7,
  aug: 8,
  sep: 9,
  oct: 10,
  nov: 11,
  dec: 12
};

// eslint-disable-next-line no-unused-vars
export const departmentOptions = Object.entries(DEPARTMENT_KEYS).map(([key, value]) => ({
  value: value,
  label: value
}));

export const mergeAndRemoveDeduplicate = (array1, array2, key) => {
  const combinedData = [...array1, ...array2];

  return combinedData.reduce((acc, current) => {
    const x = acc.find((item) => item[key] === current[key]);
    if (!x) {
      return acc.concat([current]);
    } else {
      return acc;
    }
  }, []);
};

export const getRelativeTime = (timestamp) => {
  const currentTime = new Date().getTime();
  const timeDifference = currentTime - timestamp;

  const seconds = Math.floor(timeDifference / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days >= 3) {
    const date = new Date(timestamp);
    return date.toLocaleDateString(); // Format the date as per your locale, or customize it as needed
  } else if (minutes < 1) {
    return `${seconds} sec`;
  } else if (minutes < 60) {
    return `${minutes} min`;
  } else if (hours < 24) {
    return `${hours} hours`;
  } else {
    return `${days} days`;
  }
};

export const formattedAverage = (average) => {
  // Round the average to one decimal place
  const rounded = Math.round(average * 10) / 10;

  // Format the rounded average to one decimal place if it's a whole number
  return rounded % 1 === 0 ? rounded.toFixed(1) : rounded;
};

export const unique = (array, propertyName) => {
  return array.filter((e, i) => array.findIndex((a) => a[propertyName] === e[propertyName]) === i);
};

// Define the ranges
export const RANGES = {
  [DATE_FILTER_KEYS.TODAY]: {
    label: 'Today',
    start: moment().startOf('day').valueOf(),
    end: moment().endOf('day').valueOf()
  },
  [DATE_FILTER_KEYS.THIS_WEEK]: {
    label: 'This Week',
    start: moment().startOf('week').valueOf(),
    end: moment().endOf('week').valueOf()
  },
  [DATE_FILTER_KEYS.THIS_MONTH]: {
    label: 'This Month',
    start: moment().startOf('month').valueOf(),
    end: moment().endOf('month').valueOf()
  },
  [DATE_FILTER_KEYS.THIS_YEAR]: {
    label: 'This Year',
    start: moment().startOf('year').valueOf(),
    end: moment().endOf('year').valueOf()
  }
};

// Check if the file is an image based on common image extensions
export const isImage = (fileUrl) => {
  const imageExtensions = ['jpg', 'jpeg', 'png', 'gif'];
  const extension = fileUrl?.split('.').pop()?.toLowerCase();
  return imageExtensions.includes(extension);
};

export const getFileIcon = (fileUrl) => {
  const iconOptions = {};

  // Extract file extension from URL
  const extension = fileUrl?.split('.').pop()?.toLowerCase();

  if (!extension) return null; // If no extension found, handle accordingly

  // Handle common file types based on extension
  switch (extension) {
    case 'doc':
    case 'docx':
      return <FileIcon extension="docx" {...iconOptions} />;
    case 'xls':
    case 'xlsx':
      return <FileIcon extension="xlsx" {...iconOptions} />;
    case 'csv':
      return <FileIcon extension="csv" {...iconOptions} />;
    case 'pdf':
      return <FileIcon extension="pdf" {...iconOptions} />;
    case 'zip':
      return <FileIcon extension="zip" {...iconOptions} />;
    default:
      return <FileIcon extension={extension} {...iconOptions} />; // Fallback to generic icon
  }
};

export const getFileIconS3Url = (fileUrl) => {
  const iconOptions = {};

  if (!fileUrl) return null;

  // Remove query params if present
  const cleanUrl = fileUrl.split('?')[0];

  // Extract extension
  const extension = cleanUrl.split('.').pop()?.toLowerCase();

  if (!extension) return <FileIcon extension="default" {...iconOptions} />;

  switch (extension) {
    case 'doc':
    case 'docx':
      return <FileIcon extension="docx" {...iconOptions} />;
    case 'xls':
    case 'xlsx':
      return <FileIcon extension="xlsx" {...iconOptions} />;
    case 'csv':
      return <FileIcon extension="csv" {...iconOptions} />;
    case 'pdf':
      return <FileIcon extension="pdf" {...iconOptions} />;
    case 'zip':
      return <FileIcon extension="zip" {...iconOptions} />;
    case 'png':
    case 'jpg':
    case 'jpeg':
    case 'gif':
      return <FileIcon extension="image" {...iconOptions} />; // generic image icon
    default:
      return <FileIcon extension="default" {...iconOptions} />; // fallback
  }
};

export const convertMinutesToHoursAndMinutes = (seconds) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  return `${hours}h ${minutes}m`;
};

// Custom function to calculate fromDate and toDate based on type
export const getDatesForType = (type) => {
  const today = moment(); // Using moment.js for date manipulation
  let startDate = today;
  let endDate = today;

  switch (type) {
    case TODAY: {
      startDate = today.clone().startOf('day');
      endDate = today.clone().endOf('day');
      break;
    }
    case THIS_WEEK: {
      startDate = today.clone().startOf('week');
      endDate = today.clone().endOf('week');
      break;
    }
    case THIS_MONTH: {
      startDate = today.clone().startOf('month');
      endDate = today.clone().endOf('month');
      break;
    }
    default:
      break;
  }

  return {
    fromDate: startDate.toISOString(), // Ensure you store the date in ISO string format
    toDate: endDate.toISOString() // Ensure you store the date in ISO string format
  };
};

export const formatTimestamp = (timestamp, format) => moment(timestamp || undefined).format(format);

export const formatMillisecondsToTime = (milliseconds, format) =>
  moment.utc(milliseconds).format(format);

// export const formatterTime = (val) => {
//   const hours = Math.floor(val / 60);
//   const minutes = Math.round(val % 60);
//   if (hours === 0) return `${minutes} min`;
//   if (minutes === 0) return `${hours} hr`;
//   return `${hours} hr ${minutes} min`;
// };

export const formatterTime = (val) => {
  let totalSeconds = Math.round(Number(val) || 0);
  if (totalSeconds < 0) totalSeconds = 0;

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const parts = [];
  if (hours > 0) parts.push(`${hours}h`);
  if (minutes > 0) parts.push(`${minutes}m`);
  if (seconds > 0 || parts.length === 0) parts.push(`${seconds}s`);

  return parts.join(' ');
};
